import BonusIssued from '../../components/Bonus/Issued/Issued';
import { ActionType } from '../../enums';

import { TXTCLI_CongratulationsX_you_have_a_ne_ELL, TXTCLI_OK } from './Bonus.Issued.messages.json';

export default {
  front: {
    view: BonusIssued,
    viewConfig: {
      title: { tag: TXTCLI_CongratulationsX_you_have_a_ne_ELL },
      actions: [
        {
          actionType: ActionType.Primary,
          actionLabel: { tag: TXTCLI_OK }
        }
      ]
    }
  }
};
